
<template>
  <div id="supportConfirm">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'arrow_flow2'"
          />
          <section>
            <h1>お問い合わせ完了</h1>
            <p class="thanks">
              お問合せありがとうございました。<br>
              お問合せ内容確認メールを自動送信しました。
            </p>
          </section>
          <div class="detail_btn2 btn_pos_center" @click="top()">トップページへ 〉〉</div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  name: 'SupportComplete',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'supportComplete',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'supportInput', key: 'supportInput', title: 'お問い合わせ入力'},
        {id: 'supportConfirm', key: 'supportConfirm', title: 'お問い合わせ内容確認'},
        {id: 'supportComplete', key: 'supportComplete', title: 'お問い合わせ完了'}
      ]
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    top: function () {
      this.$router.push('/mmstyle/top')
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSupportComplete.vue